exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".theline[data-v-520a38b5]{padding:1rem 0;padding-bottom:0}.quota[data-v-520a38b5]{border:1px dashed #333}@media (max-width:600px){.theline[data-v-520a38b5]{padding:0;margin:0;margin-left:auto}.blockRow[data-v-520a38b5]{padding:0}.block[data-v-520a38b5]{margin:.125rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-520a38b5&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/TheLine.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-520a38b5&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/TheLine.vue
// module chunks = 0